exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1500px){.container-fluid[data-v-4cf870b2]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-4cf870b2]{width:60%}}.lnk[data-v-4cf870b2]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4cf870b2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/users/UserEdit.vue
// module id = 144
// module chunks = 0